// extracted by mini-css-extract-plugin
export default {"mainContainer":"Main_mainContainer__VQw3O","row":"Main_row__Cb+mi","img":"Main_img__xuyJL"};